<template>
    <div class="prop-box">

        <el-form-item label="模板">
            <el-select v-model="myObj.config.template" placeholder="请选择">
                <el-option v-for="item, index in templateOptions" :key="index" :label="item.name" :value="item.value">
                </el-option>
            </el-select>
        </el-form-item>

    </div>

</template>

<script>


export default {
    name: "MineProp",
    components: {
    },
    props: ['obj'],
    data() {
        return {
            myObj: this.obj,
            templateOptions: [
                { name: '模板1', value: 1 },
                { name: '模板2', value: 2 },
                { name: '模板3', value: 3 },
                { name: '模板4', value: 4 },
                { name: '模板5', value: 5 },
                { name: '模板6', value: 6 },
                { name: '模板7', value: 7 },
                { name: '模板8', value: 8 },
                { name: '模板9', value: 9 },
                { name: '模板10', value: 10 }]
        }
    },
    methods: {
    }
}
</script>

<style scoped lang="less">
.el-input {
    width: 120px;
}

.materialItem {
    width: 100%;
    text-align: center;
    margin-bottom: 5px;
}
</style>